import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-end mt-3" }
const _hoisted_2 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_CreateInvoiceProduct = _resolveComponent("CreateInvoiceProduct")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_SelectProduct = _resolveComponent("SelectProduct")!
  const _component_v_date_picker_wrapper = _resolveComponent("v-date-picker-wrapper")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_LegalForm = _resolveComponent("LegalForm")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_company_table = _resolveComponent("company-table")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_editCompany = _resolveComponent("editCompany")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_ctx.invoice)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        style: {"background-color":"transparent","width":"100%"},
        elevation: "0",
        class: "oss-card"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, {
            class: _normalizeClass([
                !_ctx.$vuetify.display.mobile
                    ? 'title font-weight-regular justify-space-between'
                    : 'title font-weight-regular pa-1'
            , "d-flex flex-row justify-between"])
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.stepTitle), 1),
              (!_ctx.$vuetify.display.mobile)
                ? (_openBlock(), _createBlock(_component_v_avatar, {
                    key: 0,
                    color: "secondary lighten-2",
                    class: "subheading white--text",
                    size: "24",
                    textContent: _toDisplayString(_ctx.stepNumber)
                  }, null, 8, ["textContent"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_v_window, {
            modelValue: _ctx.wizardStep,
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.wizardStep) = $event)),
            style: {"min-height":"27vh"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pa-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        label: "Titre (Optionnel)",
                        outlined: "",
                        autofocus: "",
                        modelValue: _ctx.invoice.title,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.invoice.title) = $event)),
                        readonly: _ctx.isLocked,
                        "data-cy": "invoiceWizard-title",
                        density: "compact"
                      }, null, 8, ["modelValue", "readonly"]),
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_v_btn, {
                          rounded: "",
                          elevation: "0",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.routeToEdition())),
                          "data-cy": "invoiceWizard-next",
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[34] || (_cache[34] = [
                            _createTextVNode(" Passer directement à l'édition ")
                          ])),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "px-0 py-3 fill-height d-flex align-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "inside_card",
                        width: "100%",
                        elevation: "0",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogEditCompany = true)),
                        "data-cy": "InvoiceWizard-client"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, {
                            "primary-title": "",
                            style: {"padding-top":"5px","padding-bottom":"5px"},
                            class: "d-flex flex-row justify-between justify-space-between"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.userCompany.name), 1),
                              _createVNode(_component_v_btn, {
                                rounded: "",
                                size: "small",
                                elevation: "0",
                                "data-cy": "invoiceWizard-edit-company"
                              }, {
                                default: _withCtx(() => [
                                  _cache[36] || (_cache[36] = _createTextVNode(" éditer ")),
                                  _createVNode(_component_v_icon, {
                                    class: "ml-2",
                                    size: "small",
                                    right: ""
                                  }, {
                                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                                      _createTextVNode("$edit")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: _normalizeClass(_ctx.userCompany.siret ? '' : 'text-red')
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Siret : " + _toDisplayString(_ctx.getSiretValue(_ctx.userCompany.siret) || "manquant"), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: _normalizeClass([
                                        _ctx.userCompany.address ||
                                        _ctx.userCompany.postalCode ||
                                        _ctx.userCompany.city
                                            ? ''
                                            : 'text-red'
                                    , "text--muted"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Adresse : " + _toDisplayString(_ctx.userCompany.address) + " " + _toDisplayString(_ctx.userCompany.postalCode) + " " + _toDisplayString(_ctx.userCompany.city), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: _normalizeClass(_ctx.userCompany.legalForm ? '' : 'text-red')
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("settings.legalForm")) + " : " + _toDisplayString(_ctx.userCompany.legalForm), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  (_ctx.displayRegistrationTown)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "12",
                                        class: _normalizeClass(_ctx.userCompany.registrationTown ? '' : 'text-red')
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Ville d'enregistrement RCS : " + _toDisplayString(_ctx.userCompany.registrationTown), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["class"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      (_ctx.invoice.client && _ctx.invoice.client.name)
                        ? (_openBlock(), _createBlock(_component_v_card, {
                            key: 0,
                            class: "inside_card",
                            elevation: "0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, { style: {"padding-top":"5px","padding-bottom":"5px"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        "primary-title": ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.invoice.client ? _ctx.invoice.client.name : ""), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Adresse : " + _toDisplayString(_ctx.invoice.client.address) + " " + _toDisplayString(_ctx.invoice.client.postalCode) + " " + _toDisplayString(_ctx.invoice.client.city), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "py-2 align-self-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex justify-center align-center my-auto"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                dark: "",
                                size: "small",
                                elevation: "0",
                                rounded: "",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.setClientStep()), ["stop"])),
                                "data-cy": "invoiceWizard-select-client"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.invoice.client && _ctx.invoice.client.id
                                        ? "Choisir un autre client"
                                        : "Choisir un client"), 1),
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    class: "ml-2",
                                    right: ""
                                  }, {
                                    default: _withCtx(() => _cache[37] || (_cache[37] = [
                                      _createTextVNode("$edit")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      (_ctx.selectVATType)
                        ? (_openBlock(), _createBlock(_component_v_radio_group, {
                            key: 0,
                            modelValue: _ctx.invoice.vatType,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.invoice.vatType) = $event)),
                            inline: "",
                            color: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio, {
                                label: "Aucun",
                                value: "NO_VAT_TYPE"
                              }),
                              _createVNode(_component_v_radio, {
                                label: "Intracom",
                                value: "INTRACOM"
                              }),
                              _createVNode(_component_v_radio, {
                                label: "Export",
                                value: "EXPORT"
                              }),
                              _createVNode(_component_v_radio, {
                                label: "Autoliquidation",
                                value: "REVERSE_CHARGE"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_list, { lines: "two" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice.lines, (income, i) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: i,
                              class: _normalizeClass(
                                !_ctx.$vuetify.display.mobile
                                    ? 'mb-2 py-2 oss-list-item'
                                    : 'mb-2 pa-2 oss-list-item'
                            )
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_btn_trash, {
                                  onClick: ($event: any) => (_ctx.deleteLine(i))
                                }, null, 8, ["onClick"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(income.title), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString("Réf : " + income.reference ? income.reference + " -" : "") + " " + _toDisplayString("HT : " + _ctx.newCommonFormatCurrency(income.netAmount, undefined)) + " (" + _toDisplayString(income.vatRate) + " %)", 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["class"]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      (_ctx.invoice.lines.length)
                        ? (_openBlock(), _createBlock(_component_v_card, {
                            key: 1,
                            class: "inside_card",
                            elevation: "0",
                            "py-3": "",
                            "mb-3": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  (_ctx.isVatSubject)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "6",
                                        "px-2": "",
                                        class: "d-flex justify-end"
                                      }, {
                                        default: _withCtx(() => _cache[38] || (_cache[38] = [
                                          _createElementVNode("strong", null, "Total HT", -1)
                                        ])),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.isVatSubject)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 1,
                                        cols: "6",
                                        "px-2": "",
                                        class: "d-flex justify-end"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.netAmountTotal, undefined)), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.isVatSubject)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 2,
                                        cols: "6",
                                        "px-2": "",
                                        class: "d-flex justify-end"
                                      }, {
                                        default: _withCtx(() => _cache[39] || (_cache[39] = [
                                          _createTextVNode(" Total TVA ")
                                        ])),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.isVatSubject)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 3,
                                        cols: "6",
                                        "px-2": "",
                                        class: "d-flex justify-end"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(_ctx.vatAmountTotal, undefined)), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_col, {
                                    cols: "6",
                                    "px-2": "",
                                    class: "d-flex justify-end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("strong", null, "Total " + _toDisplayString(_ctx.isVatSubject ? "TTC" : ""), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "6",
                                    "px-2": "",
                                    class: "d-flex justify-end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.grossAmountTotal, undefined)), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "mt-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "d-flex justify-space-between" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                elevation: "0",
                                rounded: "",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.wizardStep = 5)),
                                disabled: !_ctx.products.length,
                                "data-cy": "invoiceWizard-addExistingProduct",
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[40] || (_cache[40] = [
                                  _createTextVNode(" Ajouter un produit enregistré ")
                                ])),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_component_v_btn, {
                                elevation: "0",
                                dark: "",
                                rounded: "",
                                size: "small",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.wizardStep = 4)),
                                "data-cy": "InvoiceWizard-newProduct"
                              }, {
                                default: _withCtx(() => _cache[41] || (_cache[41] = [
                                  _createTextVNode(" Ajouter un nouveau produit ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "py-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "inside_card px-2 mb-6",
                        elevation: "0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CreateInvoiceProduct, {
                            ref: "createInvoiceProduct",
                            vatSubject: _ctx.isVatSubject,
                            companyId: _ctx.companyId,
                            saveable: true,
                            onProduct: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setExistingProduct($event))),
                            onProductCreated: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addLine($event)))
                          }, null, 8, ["vatSubject", "companyId"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "6",
                            class: "pr-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_oss_text_field_filled, {
                                outlined: "",
                                "onUpdate:modelValue": [
                                  _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateLineAmounts(_ctx.income))),
                                  _cache[10] || (_cache[10] = ($event: any) => ((_ctx.income.quantity) = $event))
                                ],
                                label: "Quantité",
                                suffix: '',
                                dense: "",
                                "data-cy": "invoiceWizard-newProduct-quantity",
                                modelValue: _ctx.income.quantity
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "6",
                            "pl-1": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_oss_text_field_filled, {
                                outlined: "",
                                readonly: "",
                                label: "Montant HT",
                                dense: "",
                                modelValue: _ctx.incomeNetAmount,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.incomeNetAmount) = $event)),
                                "data-cy": "InvoiceWizard-montantHT"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "pt-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "pb-3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                outlined: "",
                                modelValue: _ctx.income.quantity,
                                "onUpdate:modelValue": [
                                  _cache[12] || (_cache[12] = ($event: any) => ((_ctx.income.quantity) = $event)),
                                  _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateLineAmounts(_ctx.income)))
                                ],
                                modelModifiers: { number: true },
                                type: "number",
                                label: "Quantité",
                                "data-cy": "invoiceWizard-existingProduct-quantity",
                                density: "compact"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_SelectProduct, {
                                companyId: _ctx.companyId,
                                invoiceProductType: 'PRODUCT',
                                onProduct: _ctx.setExistingProduct
                              }, null, 8, ["companyId", "onProduct"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          (_ctx.gonnaBeRecurrenceInvoice)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_date_picker_wrapper, {
                                    modelValue: _ctx.invoiceStartDate,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.invoiceStartDate) = $event)),
                                    type: "date",
                                    width: "100%",
                                    landscape: !_ctx.$vuetify.display.mobile,
                                    class: "elevation-0",
                                    color: "gradient",
                                    scrollable: "",
                                    "allowed-dates": _ctx.allowedDates
                                  }, null, 8, ["modelValue", "landscape", "allowed-dates"])
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_date_picker_wrapper, {
                                    modelValue: _ctx.invoiceDate,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.invoiceDate) = $event)),
                                    type: "date",
                                    width: "100%",
                                    landscape: !_ctx.$vuetify.display.mobile,
                                    class: "elevation-0",
                                    color: "gradient",
                                    "allowed-dates": _ctx.allowedDates,
                                    "data-cy": "InvoiceWizard-emission"
                                  }, null, 8, ["modelValue", "landscape", "allowed-dates"])
                                ]),
                                _: 1
                              })),
                          (_ctx.isInvoice)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 2,
                                cols: "12",
                                class: "d-flex justify-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_switch, {
                                    modelValue: _ctx.gonnaBeRecurrenceInvoice,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.gonnaBeRecurrenceInvoice) = $event)),
                                    class: "ma-2",
                                    label: "Avec récurrence"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 7 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(this.gonnaBeRecurrenceInvoice
                                ? "Date de la première facture"
                                : "Date d'émission") + ": " + _toDisplayString(_ctx.formatDate(_ctx.invoice.date)), 1),
                      (_ctx.gonnaBeRecurrenceInvoice)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            "no-gutters": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_date_picker_wrapper, {
                                    modelValue: _ctx.invoiceEndDate,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.invoiceEndDate) = $event)),
                                    type: "date",
                                    width: "100%",
                                    landscape: !_ctx.$vuetify.display.mobile,
                                    class: "elevation-0",
                                    color: "primary",
                                    scrollable: "",
                                    disabled: _ctx.isInfinitReccurency,
                                    "data-cy": "InvoiceWizard-echeance"
                                  }, null, 8, ["modelValue", "landscape", "disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_switch, {
                                    modelValue: _ctx.isInfinitReccurency,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.isInfinitReccurency) = $event)),
                                    class: "ma-2",
                                    label: "Sans date de fin"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_row, {
                            key: 1,
                            "no-gutters": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_date_picker_wrapper, {
                                    modelValue: _ctx.invoiceDueDate,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.invoiceDueDate) = $event)),
                                    width: "100%",
                                    landscape: !_ctx.$vuetify.display.mobile,
                                    class: "elevation-0",
                                    color: "gradient",
                                    scrollable: "",
                                    "allowed-dates": _ctx.allowedDueDate,
                                    "data-cy": "InvoiceWizard-fin"
                                  }, null, 8, ["modelValue", "landscape", "allowed-dates"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 8 }, {
                default: _withCtx(() => [
                  (_ctx.wizardStep === 8)
                    ? (_openBlock(), _createBlock(_component_LegalForm, {
                        key: 0,
                        companyId: _ctx.companyId,
                        onPaymentDetailsChanged: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onInvoicePaymentDetailsChanged($event))),
                        onLegalNoticesChanged: _cache[21] || (_cache[21] = 
                        (data) => {
                            this.invoice.data.legalText = data;
                        }
                    ),
                        onPaymentModeChanged: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onInvoicePaymentModeChanged($event)))
                      }, null, 8, ["companyId"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 9 }, {
                default: _withCtx(() => [
                  _createVNode(_component_Logo, { companyId: _ctx.companyId }, null, 8, ["companyId"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 10 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_company_table, {
                        showGenericCompany: false,
                        showConsumerCompany: true,
                        showCustomerCompanies: true,
                        showExistingCompanies: false,
                        company: _ctx.invoice.client ? _ctx.invoice.client.name : '',
                        siret: _ctx.invoice.client ? _ctx.invoice.client.siret : '',
                        siren: _ctx.invoice.client ? _ctx.invoice.client.siren : '',
                        vatNumber: _ctx.invoice.client ? _ctx.invoice.client.vatNumber : '',
                        parentCompanyId: _ctx.selectedCompany.id,
                        wizardMode: true,
                        onSelectCompany: _ctx.companySelectedWizard
                      }, null, 8, ["company", "siret", "siren", "vatNumber", "parentCompanyId", "onSelectCompany"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 11 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reccurencyType, (recType) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: recType.value,
                                  onClick: 
                                    () => {
                                        _ctx.invoice.periodicity = recType.value;
                                    }
                                ,
                                  style: {"background":"#fff"},
                                  class: "mt-2"
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      color: "primary",
                                      icon: 
                                            _ctx.invoice.periodicity === recType.value
                                                ? '$radio_button_checked'
                                                : '$radio_button_unchecked'
                                        
                                    }, null, 8, ["icon"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(recType.text), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                outlined: "",
                                modelValue: _ctx.dueDateAmount,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.dueDateAmount) = $event)),
                                modelModifiers: { number: true },
                                type: "number",
                                label: "Nombre",
                                density: "compact"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unitsOfTime, (unit) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: unit.value,
                                  onClick: 
                                    () => {
                                        _ctx.unitOfTime = unit.value;
                                    }
                                ,
                                  style: {"background":"#fff"},
                                  class: "mt-2"
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      color: "primary",
                                      icon: 
                                            _ctx.unitOfTime === unit.value
                                                ? '$radio_button_checked'
                                                : '$radio_button_unchecked'
                                        
                                    }, null, 8, ["icon"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(unit.text), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          (!_ctx.isInfinitReccurency)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12",
                                class: "d-flex justify-center mt-1",
                                style: {"font-size":"15px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.sumUpReccurency()), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 13 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_editCompany, {
                        ref: "companyEdition",
                        "in-company": _ctx.invoice.client,
                        clientInvoiceMode: true,
                        onUpdated: _cache[24] || (_cache[24] = ($event: any) => (_ctx.updateClientInvoice($event)))
                      }, null, 8, ["in-company"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.showAction)
            ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
                default: _withCtx(() => [
                  (_ctx.wizardStep !== 10)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        rounded: "",
                        elevation: "0",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.previous())),
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[42] || (_cache[42] = [
                          _createTextVNode("Précédent")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_spacer),
                  (_ctx.wizardStep === 4)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        rounded: "",
                        elevation: "0",
                        disabled: _ctx.addIncomeVerification,
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.createProduct())),
                        "data-cy": "invoiceWizard-create-product",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[43] || (_cache[43] = [
                          _createTextVNode("Ajouter")
                        ])),
                        _: 1
                      }, 8, ["disabled"]))
                    : (_ctx.wizardStep === 5)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 2,
                          rounded: "",
                          elevation: "0",
                          disabled: _ctx.addIncomeVerification,
                          onClick: _cache[28] || (_cache[28] = ($event: any) => {
                        _ctx.addLine();
                        _ctx.wizardStep = 3;
                    }),
                          "data-cy": "invoiceWizard-add-product",
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[44] || (_cache[44] = [
                            _createTextVNode("Ajouter")
                          ])),
                          _: 1
                        }, 8, ["disabled"]))
                      : (_ctx.wizardStep === 9 || (_ctx.wizardStep === 8 && _ctx.userCompany.logo))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            (!_ctx.isLocked)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  rounded: "",
                                  elevation: "0",
                                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.saveInvoice())),
                                  loading: _ctx.isSaving,
                                  "data-cy": "invoiceWizard-create",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => _cache[45] || (_cache[45] = [
                                    _createTextVNode("Enregistrer")
                                  ])),
                                  _: 1
                                }, 8, ["loading"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_ctx.wizardStep === 13)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 4,
                              rounded: "",
                              elevation: "0",
                              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.$refs.companyEdition.upsertCompany())),
                              "data-cy": "invoiceWizard-upsertCompany",
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[46] || (_cache[46] = [
                                _createTextVNode(" Suivant ")
                              ])),
                              _: 1
                            }))
                          : (_ctx.wizardStep === 10)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 5,
                                rounded: "",
                                elevation: "0",
                                loading: _ctx.isSaving,
                                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.wizardStep = 2)),
                                disabled: _ctx.wizardStep === 2,
                                "data-cy": "invoiceWizard-cancel",
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[47] || (_cache[47] = [
                                  _createTextVNode("Annuler")
                                ])),
                                _: 1
                              }, 8, ["loading", "disabled"]))
                            : (_ctx.wizardStep !== 8 || !_ctx.userCompany.logo)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 6,
                                  rounded: "",
                                  elevation: "0",
                                  disabled: _ctx.nextVerification,
                                  onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.next())),
                                  "data-cy": "invoiceWizard-next",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => _cache[48] || (_cache[48] = [
                                    _createTextVNode("Suivant")
                                  ])),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_oss_dialog, {
            modelValue: _ctx.dialogEditCompany,
            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.dialogEditCompany) = $event)),
            fullscreen: _ctx.$vuetify.display.mobile,
            actions: _ctx.userCompanyActions,
            title: "Modifier les informations de votre société",
            width: "100vw"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_editCompany, {
                ref: "editCompany",
                companyId: _ctx.userCompany.id,
                actions: _ctx.userCompanyActions,
                onUpdated: _ctx.closeDialogEditCompany,
                vatSystemHide: true
              }, null, 8, ["companyId", "actions", "onUpdated"])
            ]),
            _: 1
          }, 8, ["modelValue", "fullscreen", "actions"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}